import React from 'react';
import { CheckIcon } from 'lucide-react';
import { outcome } from '../data/masterclass';
export function Outcome() {
  return <section aria-labelledby="outcome-heading" className="border-t border-ink-line bg-ink" data-id="element-66" data-mp="23zpwd5rgurg6">
      <div className="mx-auto w-full max-w-6xl px-6 py-16 lg:py-20" data-id="element-67" data-mp="1z63rhzrjnrux">
        <h2 id="outcome-heading" className="max-w-3xl font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-68" data-mp="1u9dc7enkd0ak">
          You’ll leave with your <span className="text-gold" data-id="element-69" data-mp="1l7duek4q5s6k">Foundation Check.</span>
        </h2>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:gap-16" data-id="element-70" data-mp="1g8sxouoolqmv">
          <div className="rounded-2xl border border-gold/35 bg-ink-soft p-8" data-id="element-71" data-mp="1gawyv4v74bjg">
            <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-72" data-mp="1bbamexn6yzbp">
              Your alignment scores
            </p>
            <dl className="mt-8 space-y-7" data-id="element-73" data-mp="35nqxcbqxn1mw">
              {outcome.scores.map(score => <div key={score} data-id="element-74" data-mp="14pe7io9bz1m1">
                  <div className="flex items-baseline justify-between gap-4" data-id="element-75" data-mp="14p4pbmuj1yqw">
                    <dt className="font-display text-xl font-semibold uppercase text-white" data-id="element-76" data-mp="18qq2zaevyh25">
                      {score}
                    </dt>
                    <dd className="font-display text-3xl font-bold text-gold tabular-nums" data-id="element-77" data-mp="usro83wnkim4">
                      __ / 10
                    </dd>
                  </div>
                  <div className="mt-3 h-px w-full bg-gold/25" aria-hidden="true" data-id="element-78" data-mp="1nfm5yt2353vw" />
                </div>)}
            </dl>

            <ul className="mt-10 space-y-2.5 border-t border-ink-line pt-8" data-id="element-79" data-mp="1dquh4tsbmzp7">
              {outcome.includes.map(item => <li key={item} className="flex items-start gap-3 text-white/70" data-id="element-80" data-mp="1inkwfewaxr9k">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-81" data-mp="26doyhhtudiyg" />
                  <span data-id="element-82" data-mp="2b79n4j9jp0kz">{item}</span>
                </li>)}
            </ul>
          </div>

          <div data-id="element-83" data-mp="2g2cewyqo3wtd">
            <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-84" data-mp="2g1uc1j9i2kch">
              Five questions you’ll leave having answered
            </p>
            <ol className="mt-8 divide-y divide-ink-line border-y border-ink-line" data-id="element-85" data-mp="2b5c8unttiu29">
              {outcome.questions.map((question, i) => <li key={question} className="flex items-baseline gap-5 py-5 text-xl text-white/80 sm:text-2xl" data-id="element-86" data-mp="222um88a93zeq" data-mpi={i}>
                  <span className="font-display text-base font-bold text-gold/60 tabular-nums" data-id="element-87" data-mp="1xa1klta2x76v">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span data-id="element-88" data-mp="1nfhyccwz1hl6">{question}</span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}